import {Controller} from "@hotwired/stimulus"
import EmblaCarousel from "embla-carousel"

export default class extends Controller {
  static targets = ["viewport", "prevButton", "nextButton"]

  connect() {
    this.carousel = EmblaCarousel(this.viewportTarget, {
      loop: false,
      align: "start",
      containScroll: "trimSnaps"
    })

    this.carousel.on("select", this.toggleButtons.bind(this))
    this.carousel.on("reInit", this.toggleButtons.bind(this))
    this.carousel.on("resize", this.toggleButtons.bind(this))

    this.toggleButtons()

  }

  disconnect() {
    if (this.carousel) this.carousel.destroy()
  }

  next() {
    if (this.carousel) this.carousel.scrollNext()
  }

  prev() {
    if (this.carousel) this.carousel.scrollPrev()
  }

  // Show or Hide the arrow
  toggleButtons() {
    if (!this.carousel) return

    const canScroll = this.carousel.scrollSnapList().length > 1

    if (!canScroll) {
      if (this.hasPrevButtonTarget) this.prevButtonTarget.classList.add("hidden")
      if (this.hasNextButtonTarget) this.nextButtonTarget.classList.add("hidden")
      return
    }

    // Left Arrow
    if (this.hasPrevButtonTarget) {
      if (!this.carousel.canScrollPrev()) {
        this.prevButtonTarget.classList.add("hidden")
      } else {
        this.prevButtonTarget.classList.remove("hidden")
      }
    }

    // Right Arrow
    if (this.hasNextButtonTarget) {
      if (!this.carousel.canScrollNext()) {
        this.nextButtonTarget.classList.add("hidden")
      } else {
        this.nextButtonTarget.classList.remove("hidden")
      }
    }
  }
}
